module.exports = __webpack_public_path__ + "img/qrcode.0f370da4.jpg";